import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { BetaFoundersManagement } from '../../components/admin/BetaFoundersManagement';

export function BetaFoundersPage() {
  return (
    <AdminLayout
      title="Beta Founders"
      description="Gérez le programme Beta Founders et les candidatures"
    >
      <BetaFoundersManagement />
    </AdminLayout>
  );
}
